import { extractFieldKeyFromSelector } from '../utils';

export function detectOptionFilter(script, ownerFieldKey) {
  if (!script) return null;

  const lookupMap = extractLookupMap(script);
  if (lookupMap) {
    const target = extractTargetFromQuerySelectorAll(script);
    if (target) {
      const result = {
        target,
        strategy: 'valueStartsWith',
        map: lookupMap,
      };
      const driverEvent = extractDriverEvent(script);
      if (driverEvent) result.driverEvent = driverEvent;
      return result;
    }
  }

  const whitelist = extractTemplateWhitelist(script);
  if (whitelist) {
    const target = extractTargetFromQuerySelectorAll(script);
    if (target) {
      return {
        target,
        strategy: 'templateWhitelist',
        map: whitelist,
      };
    }
  }

  const substringMap = extractTemplateSubstring(script);
  if (substringMap) {
    const target = extractTargetFromQuerySelectorAll(script);
    if (target) {
      return {
        target,
        strategy: 'templateSubstring',
        map: substringMap,
      };
    }
  }

  return null;
}

function extractLookupMap(script) {
  const m = script.match(/(?:let|var|const)\s+\w+\s*=\s*(\{[^}]+\})\s*;?\s*(?:const|let|var)\s+selectedType\s*=/);
  if (!m) return null;
  return parseObjectLiteral(m[1]);
}

function parseObjectLiteral(raw) {
  const map = {};
  const pairPattern = /["']([^"']+)["']\s*:\s*["']([^"']+)["']/g;
  let pair;
  while ((pair = pairPattern.exec(raw)) !== null) {
    map[pair[1]] = pair[2];
  }
  return Object.keys(map).length > 0 ? map : null;
}

function extractTargetFromQuerySelectorAll(script) {
  const m = script.match(/querySelectorAll\(\s*(?:"([^"]+)"|'([^']+)')\s*\)/);
  const selector = m && (m[1] ?? m[2]);
  return selector ? extractFieldKeyFromSelector(selector) : null;
}

function extractDriverEvent(script) {
  const m = script.match(/window\.addEventListener\(\s*["']([^"']+)["']/);
  return m ? m[1] : null;
}

function extractTemplateWhitelist(script) {
  const pattern = /selectedType\s*==\s*["']([^"']+)["']\s*&&\s*item\.value\s*==\s*["']([^"']+)["'][\s\S]{0,120}?item\.value\s*==\s*["']([^"']+)["']/g;
  const map = {};
  let m;
  while ((m = pattern.exec(script)) !== null) {
    const template = m[1];
    const allowed  = m[2];
    const neutral  = m[3];
    if (!map[template]) map[template] = [];
    if (!map[template].includes(allowed)) map[template].push(allowed);
    if (!map[template].includes(neutral)) map[template].push(neutral);
  }
  return Object.keys(map).length > 0 ? map : null;
}

function extractTemplateSubstring(script) {
  const pattern = /selectedType\s*==\s*["']([^"']+)["']\s*&&\s*selectedType\.includes\(\s*item\.value\s*\)/g;
  const map = {};
  let m;
  while ((m = pattern.exec(script)) !== null) {
    map[m[1]] = true;
  }
  return Object.keys(map).length > 0 ? map : null;
}

